import "../libs/incremental-input"
export default context => {
    $('input.incremental-input', context).incrementInput()
}
